// src/encounter/intelligence/rail-close.ts
//
// PROD-3388 (Antonin, 3 Nov: "keep it visible everywhere, never collapsed. It also needs a close"). The screen that holds the
// Scrips Intelligence rail gives it its close here: the pre-visit (pre-encounter-rail-view.tsx) and the started encounter's
// long page (encounter-shell-view.tsx). The rail draws its X only when a screen gave one; the orb button reopens it
// (IntelligenceFab). Kept apart from the components so a component file exports components only (react-refresh).
import { createContext } from 'react';

export const IntelligenceCloseContext = createContext<(() => void) | undefined>(undefined);
